import type { PropsWithChildren, ReactNode } from "react";

interface AuthShellProps extends PropsWithChildren {
  title: string;
  description?: ReactNode;
}

export function AuthShell({ title, description, children }: AuthShellProps) {
  return (
    <div className="bg-gradient-primary min-vh-100 d-flex align-items-center py-5">
      <a className="skip-link" href="#main-content">跳至主要內容</a>
      <main id="main-content" className="container" tabIndex={-1}>
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-9 col-md-10">
            <div className="card o-hidden border-0 shadow-lg">
              <div className="card-body p-5">
                <header className="text-center mb-4">
                  <h1 className="h3 text-gray-900">{title}</h1>
                  {description && <div className="text-muted">{description}</div>}
                </header>
                {children}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

